import { CommonService } from '../app/services/common.service';
import { EventEmitter, Injectable } from "@angular/core";
import { userOne } from "./user.service.mock";
import { Observable, of } from 'rxjs';
import { User } from '@app/models/user';
import { UserChangeEvent, UserEventType } from '@app/services/auth.service';

class DefaultUserChangeEvent implements UserChangeEvent {
  type: UserEventType;
  user: User;

  constructor(type, user) {
      this.type = type;
      this.user = user;
  }
}

@Injectable(
  {
    providedIn: 'root'
  }
)
export class AuthService {
  onUserChange: EventEmitter<UserChangeEvent> = new EventEmitter<UserChangeEvent>();

  constructor(private commonService: CommonService) { }
  token: string = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzdXBlcmFkbWluIiwiY3JlYXRlZCI6MTY2NjE4NDMxMjc5OSwiaXNzIjoiZTRhYmRmNjItNGZmMi00MTAyLTliZGYtODNjZDM1ZDQ5NTEyIiwiZGV2aWNlSWQiOiIifQ.NiGLsc2alHyI-v5Ylx-uUVajCTWaGseIuW7ZzSvyZztEszZX7GY7AFLOVF6nFEtK77vIiKHTE8LVGWTigs_L2g';

  public authenticate(username: string, password: string): Observable<User> {
    console.log('call mock auth service')
    this.commonService.setCurrentToken(this.token);
    this.commonService.setCurrentUser(userOne);
    this.onUserChange.emit(new DefaultUserChangeEvent('login', this.cloneUser(userOne)));

    return of(userOne)

  }

  forgetPassword(userEmail: string):Observable<Boolean> {
    return of(true)
}
public logout(): void {
    sessionStorage.clear();
    this.onUserChange.emit(new DefaultUserChangeEvent('logout', null));
}

public isLoggedIn(): boolean {
    if (this.commonService.getCurrentToken() == null || this.commonService.getCurrentToken().trim() === '') {
        return false;
    } else {
        return true;
    }
}

  private cloneUser(user: User): User {
        return <User>JSON.parse(JSON.stringify(user));
    }
}